var isSupportWebp =
    !![].map &&
    document
        .createElement('canvas')
        .toDataURL('image/webp')
        .indexOf('data:image/webp') == 0;

function handleImagePreview(url, size) {
    if (!url) {
        return '';
    }

    let handleUrl = '';
    let aliQuality = '/quality,Q_85';
    let aliQualityBig = '/quality,Q_90';
    let oriSize = size;

    if (!size) size = '400x0';
    // 处理京东图片
    if (url.match('360buyimg.com')) {
        if (size == '400x0' && /jfs/.test(url)) {
            url = url.replace('jfs', `s400x400_jfs`);
        }

        if (isSupportWebp) {
            handleUrl = `${url}!q70.dpg.webp`;
        } else {
            handleUrl = `${url}!q70.dpg`;
        }
    } else if (url.match('haitao.') || url.match('yanxuan.')) {
        if (isSupportWebp) {
            handleUrl = `${url}?imageView&thumbnail=${size}&quality=65&type=webp`;
        } else {
            handleUrl = `${url}?imageView&thumbnail=${size}&quality=65`;
        }
    } else if (url.match('img.alicdn.com')) {
        if (size == '400x0') {
            size = 400;
        }
        handleUrl = `${url}_${size}x${size}q85s150.jpg`;
    } else if (url.match('akmer.aikucun.com')) {
        if (size == '400x0') {
            size = '?x-oss-process=image/resize,w_400' + aliQuality;
        } else {
            size = '';
        }
        handleUrl = `${url}${size}`;
    } else if (url.match('imgcdn.chuxingyouhui.com')) {
        if (oriSize == '400x0') {
            size = '?x-oss-process=image/resize,w_400' + aliQuality;
        } else if (oriSize == '800x0') {
            size = '?x-oss-process=image/resize,w_800' + aliQualityBig;
        } else {
            size = '';
        }
        handleUrl = `${url}${size}`;
    } else if (url.match('h5.chuxingyouhui.com')) {
        if (oriSize == '400x0') {
            size = '?x-oss-process=image/resize,w_400' + aliQuality;
        } else if (oriSize == '800x0') {
            size = '?x-oss-process=image/resize,w_800' + aliQualityBig;
        } else if (oriSize == '200x0') {
            size = '?x-oss-process=image/resize,w_200' + aliQualityBig;
        } else {
            size = '';
        }
        handleUrl = `${url}${size}`;
    } else if (url.match('t00img.yangkeduo.com')) {
        // 拼多多详情页，
        handleUrl = `${url}?imageMogr2/quality/70`;
    } else if (url.match('myhuaweicloud.com') || url.match('yd-imgs.380star.com')) {
        if (size == '400x0') {
            size = '?x-image-process=image/resize,m_pad,h_400,w_400';
        } else {
            size = '';
        }
        handleUrl = `${url}${size}`;
    } else if (url.match('cdn.haoyiku.com.cn')) {
        if (size == '400x0') {
            size = '?x-oss-process=image/resize,w_400' + aliQuality;
        } else {
            size = '';
        }
        handleUrl = `${url}${size}`;
    } else if (url.match('imgservice.suning.cn')) {
        if (size == '400x0') {
            size = '_400w_400h_4e';
        } else {
            size = '';
        }
        handleUrl = `${url}${size}`;
    }

    if (!handleUrl) handleUrl = url;

    handleUrl = handleUrl.replace('http://', 'https://');

    if (handleUrl.indexOf('haitao.nos.netease.com') != -1) {
        handleUrl = handleUrl.replace('http://', 'https://');
    }

    return handleUrl;
}

export default handleImagePreview;
